import { auditTime, defer, filter, fromEvent, interval, map, merge, pairwise } from 'rxjs';

const HEARTBEAT_MS = 5000;
const DRIFT_TOLERANCE_MS = 2000;

// defer keeps the document access lazy, so importing this module is safe during server-side rendering

export const appBecameActive$ = defer(() => {
  const clockJump$ = interval(HEARTBEAT_MS).pipe(
    map(() => Date.now()),
    pairwise(),
    filter(([prev, now]) => now - prev > HEARTBEAT_MS + DRIFT_TOLERANCE_MS)
  );

  return merge(
    // tab switch back / window un-minimised / mobile app switch back
    fromEvent(document, 'visibilitychange').pipe(filter(() => document.visibilityState === 'visible')),
    // alt-tab back from another application (visibility often never changed)
    fromEvent(window, 'focus'),
    // restored from back/forward cache — all JS state was frozen
    fromEvent(window, 'pageshow').pipe(filter((e) => (e as PageTransitionEvent)?.persisted)),
    // network came back, typical right after wake-from-sleep
    fromEvent(window, 'online'),
    // Page Lifecycle API: tab was frozen and unfrozen (Chromium; harmless elsewhere)
    fromEvent(document, 'resume'),
    clockJump$
  ).pipe(
    // on wake, several of these fire near-simultaneously — coalesce them
    auditTime(100),
    map(() => void 0)
  );
});
